type Jsonifiable = Parameters<(typeof JSON)['stringify']>[0];

enum ApplicationStateSessionStorageKey {
  PaymentMethods = 'app-state--PaymentMethods',
}

export class ApplicationStateSessionStorage {
  public loadPaymentMethodsState(userId: string | number) {
    return this.load(this.generateKey(ApplicationStateSessionStorageKey.PaymentMethods, userId));
  }

  public savePaymentMethodsState(data: Jsonifiable, userId: string | number) {
    return this.save(this.generateKey(ApplicationStateSessionStorageKey.PaymentMethods, userId), data);
  }

  private save(key: string, value: Jsonifiable) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  private load(key: string): null | Jsonifiable {
    const serializedValue = sessionStorage.getItem(key);

    if (!serializedValue) return null;

    return JSON.parse(serializedValue);
  }

  private generateKey(key: ApplicationStateSessionStorageKey, userId: string | number): string {
    return `${key}-${userId}`;
  }
}

export const applicationStateSessionStorage = new ApplicationStateSessionStorage();
